import React from "react";
import { Index } from "react-instantsearch";

export default function InstantSearchIndex({ indexName, children }) {
	return <Index indexName={indexName}>{children}</Index>;
}
